<script setup lang="ts">
import { PhUserFocus as UserFocus } from "@phosphor-icons/vue";

withDefaults(defineProps<{
  src?: string;
  alt?: string;
  code?: string;
  label?: string;
  variant?: "hero" | "square" | "wide";
}>(), {
  src: "",
  alt: "",
  code: "NBTI / V2",
  label: "方块人角色形象待定",
  variant: "square",
});
</script>

<template>
  <figure class="character-stage" :class="`character-stage--${variant}`">
    <div class="character-stage__topline" aria-hidden="true">
      <span>NBTI</span>
      <strong>{{ code }}</strong>
    </div>

    <div class="character-stage__art">
      <img v-if="src" :src="src" :alt="alt" decoding="async" />
      <div v-else class="character-stage__pending" role="img" :aria-label="label">
        <UserFocus :size="56" weight="duotone" />
      </div>
    </div>

    <figcaption aria-hidden="true">
      <i aria-hidden="true"></i>
    </figcaption>
  </figure>
</template>
